"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const S = __importStar(require("./Modal.styles"));
const Modal = ({ visible = false, setVisibleState, children, backgroundColor, 
// Make sure to add the alpha (transparency value) at the end of the color string
...props }) => {
    const closeModal = () => setVisibleState && setVisibleState(false);
    return (react_1.default.createElement(S.Modal, Object.assign({ animationType: "fade", transparent: true, visible: visible, onRequestClose: closeModal }, props),
        react_1.default.createElement(react_native_1.TouchableWithoutFeedback, { accessible: false, testID: "TouchableWithoutFeedback", onPress: closeModal },
            react_1.default.createElement(S.ModalContainer, { backgroundColor: backgroundColor },
                react_1.default.createElement(react_native_1.TouchableWithoutFeedback, { accessible: false },
                    react_1.default.createElement(S.ModalContent, null, children))))));
};
exports.default = Modal;
